import { render, staticRenderFns } from "./LicenseForEndUser.vue?vue&type=template&id=2dc2cbf0&scoped=true&"
import script from "./LicenseForEndUser.vue?vue&type=script&lang=js&"
export * from "./LicenseForEndUser.vue?vue&type=script&lang=js&"
import style0 from "./LicenseForEndUser.vue?vue&type=style&index=0&id=2dc2cbf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2cbf0",
  null
  
)

export default component.exports